import { useCallback } from "react";
import { taskService } from "@miplatform/api";
import { useComponentState } from "@miplatform/hooks";
import { toastService } from "@miplatform/toast";
import { useGlobalManagerApproval } from "@mibuildweb/components";

export function useAutoAssignWorkOrders(
  calendarSetId?: string,
  onSuccess?: () => void
) {
  const { executeApiRequest } = useGlobalManagerApproval();
  const stateManager = useComponentState();

  const autoAssignWorkOrders = useCallback(
    async () => {
      if (!calendarSetId) {
        return Promise.resolve();
      }

      const data = { calendarSetId };

      const onRefresh = () => {
        toastService.success({
          text: "Work order auto-assignment started",
        });
        onSuccess?.();
      };

      return stateManager.run(async () => {
        const options = await taskService.workOrders.autoAssign({
          data,
        });
        await executeApiRequest({
          options,
          callback: onRefresh,
          noInitialErrorMessage: true,
        });
      });
    },
    [calendarSetId, executeApiRequest, onSuccess, stateManager]
  );

  return {
    autoAssignWorkOrders,
    isAutoAssignLoading: stateManager.isBusy(),
  };
}
